/* Westerly footer: turns link columns into accessible accordions on mobile.
   Progressive enhancement: without JS, lists simply stay expanded. */

(function () {
  'use strict';

  const MOBILE_QUERY = '(max-width: 749px)';

  function enhance(footer) {
    if (footer.dataset.westerlyAccordion === 'true') return;
    footer.dataset.westerlyAccordion = 'true';

    footer.querySelectorAll('.footer-block--menu').forEach((block, index) => {
      const heading = block.querySelector('.footer-block__heading');
      const content = block.querySelector('.footer-block__details-content');
      if (!heading || !content) return;

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'w-footer-acc__toggle';
      button.setAttribute('aria-expanded', 'false');
      const contentId = content.id || `WesterlyFooterAcc-${index}-${Math.floor(Math.random() * 100000)}`;
      content.id = contentId;
      button.setAttribute('aria-controls', contentId);

      while (heading.firstChild) button.appendChild(heading.firstChild);
      const caret = document.createElement('span');
      caret.className = 'w-footer-acc__caret';
      caret.setAttribute('aria-hidden', 'true');
      button.appendChild(caret);
      heading.appendChild(button);

      block.classList.add('w-footer-acc');

      button.addEventListener('click', () => {
        if (!window.matchMedia(MOBILE_QUERY).matches) return;
        const open = block.classList.toggle('w-footer-acc--open');
        button.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    footer.classList.add('w-footer-acc-ready');
  }

  function initAll() {
    document.querySelectorAll('.footer').forEach(enhance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const footer = event.target.querySelector('.footer');
    if (footer) enhance(footer);
  });
})();
